import script from "./HeaderBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderBox.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderBox.vue?vue&type=style&index=0&id=029d850a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-029d850a"]])

export default __exports__